import React from "react";
// COMMON COMPONENTS DEFINED AT ONE PLACE FOR GOD'S OWN COUNTRY
import MenuLinks from "./Menu";
import footerBg from "./../assets/images/backgrounds/footer-one-bg.png";
import footerLogo from "../assets/images/Bharat_Dhara/Logo/bd_white_font_png_noslogan.png";
import newsImg1 from "./../assets/images/resources/footer-widget-news-img1.png";
import newsImg2 from "./../assets/images/resources/footer-widget-news-img2.png";

function Footer({ menuWrapperRef, menuContentRef }) {
  return (
    <section>
      <footer className="footer-one">
        <div className="footer-one__top">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="footer-one__top-wrapper">
                  <div className="footer-one__bg">
                    <img src={footerBg} alt="" style={{ width: "100%" }} />
                  </div>
                  <div className="row">
                    {/* Start Footer Widget Column */}
                    <div
                      className="col-xl-3 col-lg-6 col-md-6 wow animated fadeInUp"
                      data-wow-delay="0.1s"
                    >
                      <div className="footer-widget__column footer-widget__about">
                        <div className="footer-widget__about-logo">
                          <a href="index-main.html">
                            <img
                              src={footerLogo}
                              className="bd-footer-logo"
                              alt=""
                            />
                          </a>
                        </div>
                        <p className="footer-widget__about-text">
                          Lorem ipsum dolor sit amet consect etur adi pisicing
                          elit sed.
                        </p>
                        <div className="footer-widget__about-contact-box">
                          <p className="phone">
                            <a href="tel:123456789">
                              <i className="fas fa-phone-square-alt"></i>+92 666
                              888 0000
                            </a>
                          </p>
                          <p>
                            <a href="mailto:needhelp@company.com">
                              <i className="fa fa-envelope"></i>
                              needhelp@company.com
                            </a>
                          </p>
                          <p className="text">
                            <i className="fas fa-map-marker-alt"></i>666 road,
                            broklyn street new york
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* End Footer Widget Column */}

                    {/* Start Footer Widget Column */}
                    <div
                      className="col-xl-3 col-lg-6 col-md-6 wow animated fadeInUp"
                      data-wow-delay="0.3s"
                    >
                      <div className="footer-widget__column footer-widget__news">
                        <h2 className="footer-widget__title">News</h2>
                        <ul className="footer-widget__news-list">
                          <li className="footer-widget__news-list-item">
                            <div className="footer-widget__news-list-item-img">
                              <img src={newsImg1} alt="" />
                            </div>
                            <div className="footer-widget__news-list-item-title">
                              <p>20 Jul, 2021</p>
                              <h5>
                                <a href="#">
                                  A Clean Water Gives More
                                  <br />
                                  Good Taste
                                </a>
                              </h5>
                            </div>
                          </li>

                          <li className="footer-widget__news-list-item">
                            <div className="footer-widget__news-list-item-img">
                              <img src={newsImg2} alt="" />
                            </div>
                            <div className="footer-widget__news-list-item-title">
                              <p>20 Jul, 2021</p>
                              <h5>
                                <a href="#">
                                  A Clean Water Gives More
                                  <br />
                                  Good Taste
                                </a>
                              </h5>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {/* End Footer Widget Column */}

                    {/* Start Footer Widget Column */}
                    <div
                      className="col-xl-2 col-lg-6 col-md-6 wow animated fadeInUp"
                      data-wow-delay="0.5s"
                    >
                      <div className="footer-widget__column footer-widget__explore">
                        <h2 className="footer-widget__title">Explore</h2>
                        <ul className="footer-widget__explore-list">
                          <li className="footer-widget__explore-list-item">
                            <a href="projects.html">New Projects</a>
                          </li>
                          <li className="footer-widget__explore-list-item">
                            <a href="services.html">Our Services</a>
                          </li>
                          <li className="footer-widget__explore-list-item">
                            <a href="about.html">About Us</a>
                          </li>
                          <li className="footer-widget__explore-list-item">
                            <a href="#">Get in Touch</a>
                          </li>
                          <li className="footer-widget__explore-list-item">
                            <a href="#">Volunteers</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {/* End Footer Widget Column */}

                    {/* Start Footer Widget Column */}
                    <div
                      className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                      data-wow-delay="0.7s"
                    >
                      <div className="footer-widget__column footer-widget__newletter">
                        <h2 className="footer-widget__title">Newletter</h2>
                        <p className="footer-widget__newletter-text">
                          Sign up now to get daily latest news & updates from us
                        </p>
                        <form className="subscribe-form" action="#">
                          <input
                            type="email"
                            name="email"
                            placeholder="Email address"
                          />
                          <button type="submit">Go</button>
                        </form>
                      </div>
                    </div>
                    {/* End Footer Widget Column */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-one__bottom">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="footer-one__bottom-inner">
                  <div className="footer-one__bottom-text">
                    <p>
                      &copy; Copyright 2021 by <a href="#">Layerdrops.com</a>
                    </p>
                  </div>
                  <div className="footer-one__bottom-social-links">
                    <ul>
                      <li>
                        <a href="#">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-pinterest-p"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className="mobile-nav__wrapper" ref={menuWrapperRef}>
        <div className="mobile-nav__overlay mobile-nav__toggler"></div>
        {/* <!-- /.mobile-nav__overlay --> */}
        <div className="mobile-nav__content" ref={menuContentRef}>
          <span className="mobile-nav__close mobile-nav__toggler">
            <i className="fa fa-times"></i>
          </span>

          <div className="logo-box">
            <a href="index-main.html" aria-label="logo image">
              <img src={footerLogo} width="155" alt="" />
            </a>
          </div>
          {/* <!-- /.logo-box --> */}
          <div className="mobile-nav__container">
            <MenuLinks />
          </div>
          {/* <!-- /.mobile-nav__container --> */}

          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="icon-phone-call"></i>
              <a href="mailto:needhelp@packageName__.com">
                needhelp@agriox.com
              </a>
            </li>
            <li>
              <i className="icon-letter"></i>
              <a href="tel:666-888-0000">666 888 0000</a>
            </li>
          </ul>
          {/* <!-- /.mobile-nav__contact --> */}
          <div className="mobile-nav__top">
            <div className="mobile-nav__social">
              <a href="#" className="fab fa-twitter"></a>
              <a href="#" className="fab fa-facebook-square"></a>
              <a href="#" className="fab fa-pinterest-p"></a>
              <a href="#" className="fab fa-instagram"></a>
            </div>
            {/* <!-- /.mobile-nav__social --> */}
          </div>
          {/* <!-- /.mobile-nav__top --> */}
        </div>
        {/* <!-- /.mobile-nav__content --> */}
      </div>
    </section>
  );
}

export default Footer;
